import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { SessionIgnoreReport } from './Pages'

export const SessionIgnoreReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={SessionIgnoreReport} />
    </Fragment>
)